module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Barcode-scan-1e08d75c3439e31641d4ae34f029f375.svg";